import { api } from "@/api/client";

export type LoginCredentials = {
  grantType: string;
  userId?: string;
  password?: string;
  barcode?: string;
};

export type PasswordChangeRequest = {
  oldPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
};

export function login(credentials: LoginCredentials) {
  return api.authenticate(credentials);
}

export function changePassword(request: PasswordChangeRequest) {
  return api.post("/user/change-password", request);
}
